import EzController from 'controllers/ez-base-controller';
import Cookies from 'js-cookie';
import { getAjaxModal } from 'lib/ajax-helpers';
import { ezConfirm } from 'lib/modal_helpers';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';

export default class DownloadButtonController extends EzController {
  initialize() {
    if (document.body.dataset.userSignedIn === 'true') {
      this.disableDownloadLimitModal();
    }

    window.addEventListener('DownloadLimitModalSeen', this.disableDownloadLimitModal);
  }

  connect() {
    if (!this.isTurbolinksPreview) {
      const searchData = window.localStorage.getItem(`resource-${this.resourceId}`);
      if (searchData) {
        this.searchData = JSON.parse(searchData);
        window.localStorage.removeItem(`resource-${this.resourceId}`);
      }
    }
  }

  disconnect() {
    window.removeEventListener('DownloadLimitModalSeen', this.disableDownloadLimitModal);
  }

  freeDownload = (event) => {
    event.preventDefault();

    if (this.hasHitDownloadLimit() && !window.disableDownloadLimitModal) {
      this.openDownloadLimitModal();
    } else if (this.element.dataset.dlAdModalPath) {
      this.showDownloadAdPopup();
      triggerCustomEvent('TriggerFreeAttributionSlidedown');
    } else {
      this.triggerDownload();
    }
  }

  disableDownloadLimitModal = () => {
    window.disableDownloadLimitModal = true;
  }

  get curPopCount() {
    return parseInt(Cookies.get('pop_count'), 10) || 0;
  }

  set curPopCount(value) {
    Cookies.set('pop_count', value);
  }

  hasHitDownloadLimit() {
    return this.curPopCount >= 3;
  }

  triggerDownload = (event, reloadPage = false) => {
    const downloadFileUrl = (event && (typeof event.detail.downloadFileUrl !== 'undefined')) ? event.detail.downloadFileUrl : this.element.getAttribute('href');

    if (!window.disableDownloadLimitModal) {
      this.curPopCount += 1;
    }

    if (reloadPage) {
      window.open(downloadFileUrl, '_blank');

      window.setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      window.location.href = downloadFileUrl;
    }
  }

  showDownloadAdPopup() {
    const downloadAdModalPath = this.element.dataset.dlAdModalPath;

    this.element.setAttribute('remote', 'true');

    window.addEventListener('TriggerDownload', this.triggerDownload);

    getAjaxModal(downloadAdModalPath);
  }

  openDownloadLimitModal() {
    const downloadLimitModalPath = this.element.dataset.dlLimitModalPath;

    this.element.setAttribute('remote', 'true');

    getAjaxModal(downloadLimitModalPath);
  }

  spendCreditAndDownload = (event) => {
    // Need to reload the page so a new download button gets rendered
    this.triggerDownload(event, true);

    this.creditSpent = true;
  }

  confirmCreditSpend(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    if (this.creditSpent) {
      this.triggerDownload();
    } else {
      ezConfirm(
        event.currentTarget.getAttribute('data-confirm-text'),
        this.spendCreditAndDownload,
        ['Okay', 'Cancel'],
        {
          centered: false,
        },
      );
    }
  }

  get isTurbolinksPreview() {
    return document.documentElement.hasAttribute('data-turbolinks-preview');
  }

  get resourceId() {
    return document.querySelector('.ez-resource-show').dataset.resourceId;
  }

  get resourceType() {
    return document.querySelector('.ez-resource-show').dataset.resourceType;
  }

  sendDownloadEvent() {
    let eventDetails = {
      resourceId: this.resourceId,
      resourceType: this.resourceType,
    };

    if (this.searchData) {
      eventDetails = Object.assign(eventDetails, this.searchData);
    }

    triggerCustomEvent(events.download_btn.initial_click, eventDetails);
  }
}
